<template>
  <section id="socios" class="partners-section py-5" data-aos="fade-up">
    <h2>CONOCE A NUESTROS ALIADOS</h2>
    <div class="logos-container">
      <div class="logos-slide" :style="{ animationDuration: `${animationDuration}s` }">
        <div 
          v-for="(partner, index) in partners" 
          :key="index" 
          class="logo-item"
        >
          <img 
            :src="'/image/' + partner.image" 
            :alt="partner.name" 
            class="img-fluid"
          >
        </div>
        <!-- Duplicados para efecto infinito -->
        <div 
          v-for="(partner, index) in firstPartners" 
          :key="'dup-' + index" 
          class="logo-item"
        >
          <img 
            :src="'/image/' + partner.image" 
            :alt="partner.name" 
            class="img-fluid"
          >
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PartnersSection',
  data() {
    return {
      animationDuration: 40,
      partners: [
        { name: "Booking.com", image: "1.png" },
        { name: "Serko", image: "2.png" },
        { name: "Suffline", image: "3.png" },
        { name: "Sky", image: "4.png" },
        { name: "Business Insider", image: "5.png" },
        { name: "Edays", image: "6.png" },
        { name: "Lee Mills", image: "7.png" },
        { name: "Resonc", image: "8.png" },
        { name: "Partner 9", image: "9.png" },
        { name: "Partner 10", image: "10.png" },
        { name: "Partner 11", image: "11.png" },
        { name: "Partner 12", image: "12.png" },
        { name: "Partner 13", image: "13.png" },
        { name: "Partner 14", image: "14.png" },
        { name: "Partner 15", image: "15.png" },
        { name: "Partner 16", image: "16.png" },
        { name: "Partner 17", image: "17.png" },
        { name: "Partner 18", image: "18.png" },
        { name: "Partner 19", image: "19.png" }
      ]
    }
  },
  computed: {
    firstPartners() {
      return this.partners.slice(0, 5);
    }
  }
}
</script>

<style scoped>
.partners-section {
  background-color: #233d72;
  text-align: center;
  padding: 80px 0; /* Más alto */
}

.partners-section h2 {
  color: #ffffff;
  margin-bottom: 40px;
  font-size: 2rem;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.logos-container {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  position: relative;
}

.logos-slide {
  display: inline-block;
  animation: slide 40s linear infinite;
}

.logo-item {
  display: inline-block;
  margin: 0 30px;
  vertical-align: middle;
  width: 160px; /* Más ancho */
}

.logo-item img {
  max-height: 80px; /* Más alto */
  width: auto;
  filter: grayscale(100%);
  opacity: 0.7;
  transition: all 0.3s ease;
}

.logo-item img:hover {
  filter: grayscale(0%);
  opacity: 1;
}

@keyframes slide {
  from { transform: translateX(0); }
  to { transform: translateX(-50%); }
}
</style>
